import React, { useEffect, useRef } from 'react';
import WaykeEcomWeb from '@wayke-se/ecom-web';
import '@wayke-se/ecom-web/dist/index.css';

const WaykeEcomWrapper = ({ car, onButtonClick, onModalClose }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    const context = new WaykeEcomWeb({
      id: car._id,
      rootId: containerRef.current.id,
      ecomSdkConfig: {
        api: {
          address: 'https://ecom.wayke.se',
        },
      },
      logo: 'https://bilbolaget.nu/app/themes/bilbolaget/static/bilbolaget-small.png',
      logoX2: 'https://bilbolaget.nu/app/themes/bilbolaget/static/bilbolaget.png',
      onEvent: (view, event, step, data) => {
        console.log({
          view,
          event,
          step,
          data,
        })
        if (event === 'CLOSE') {
          onModalClose();
        }
      },
    });

    onButtonClick(context.start.bind(context));
  }, [car, onButtonClick, onModalClose]);

  return <div ref={containerRef} />;
};

export default WaykeEcomWrapper;
